import { useMemo } from 'react';

import column from '@Components/Grid/utils/column';

import LogFormatter, { DateFormatter } from './LogFormatter';

export default function useColumns() {
  return useMemo(() => [
    column.accessor('date', {
      header: 'Date',
      cellClassName: 'p-3 align-top',
      cell: info => <DateFormatter info={info} />,
      enableSorting: false,
      maxSize: 200,
    }),
    column.accessor('description', {
      header: 'Description',
      cellClassName: 'p-3 align-top',
      cell: info => <LogFormatter info={info} />,
      enableSorting: false,
    }),
  ], [])
}
